import { useLoader } from '../context/loader.context';
import LoadingComponent from './loading.component';

export default function SystemLoaderComponent() {
	const { loaderState } = useLoader();

	if (loaderState.visible) return <LoadingComponent />;
	return <></>;
}
